var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBreadcrumb)?_c('div',{staticClass:"breadcrumb-bar"},[_c('div',{staticClass:"breadcrumb-inner"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"breadcrumb-item"},[(index > 0)?_c('span',{staticClass:"breadcrumb-sep"},[_vm._v("›")]):_vm._e(),_c('div',{staticClass:"breadcrumb-chip",class:[
          step.status,
          { clickable: step.status === 'done' && step.target },
        ],on:{"click":function($event){step.status === 'done' &&
            step.target &&
            _vm.$emit('navigate-back', step.target)}}},[_c('span',{staticClass:"chip-text"},[_vm._v(_vm._s(step.label))])])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }